import { ArrowDownIcon } from '@heroicons/react/24/outline'

import { anim, prog } from '../../motion'
import { Shape } from '../../primitives'
import { Line } from '../kit'

// Zwei Zeilen Typo, dann treten Mara und Lena als große Kreise auf
export default function CinIntro() {
  return (
    <div className='cin-center'>
      <div className='cin-stack'>
        <Line at={[-1, 0]} out={[0.3, 0.4]} className='cin-display'>
          Eine Bewerbung<span style={{ color: 'var(--pink)' }}>.</span>
        </Line>
        <Line
          at={[0.08, 0.2]}
          out={[0.32, 0.42]}
          className='cin-display cin-display--soft'
        >
          Zwei Perspektiven<span style={{ color: 'var(--blue)' }}>.</span>
        </Line>
      </div>

      <div className='cin-intro-cast'>
        <div
          className='cin-person'
          style={anim({ at: [0.42, 0.6], x: -260, y: 0, s: 0.6 })}
        >
          <div className='cin-orb' style={{ background: 'var(--blue)' }}>
            M
          </div>
          <div className='cin-person__label'>Mara sucht.</div>
        </div>

        <div className='cin-intro-link'>
          <div
            className='cin-intro-link__line'
            style={{ ...prog([0.56, 0.7]), transform: 'scaleX(var(--p))' }}
          />
          <div
            className='cin-intro-link__knot'
            style={anim({ at: [0.66, 0.76], s: 0.2, y: 0, r: -90 })}
          >
            <Shape kind='tri' color='yellow' size={30} />
            <Shape kind='sq' color='green' size={24} />
            <Shape kind='dot' color='pink' size={24} />
          </div>
        </div>

        <div
          className='cin-person'
          style={anim({ at: [0.42, 0.6], x: 260, y: 0, s: 0.6 })}
        >
          <div className='cin-orb' style={{ background: 'var(--pink)' }}>
            L
          </div>
          <div className='cin-person__label'>Lena bewirbt sich.</div>
        </div>
      </div>

      <Line at={[0.76, 0.88]} y={24} className='cin-intro-caption'>
        Aivy bringt beide zusammen. Wissenschaftlich fundiert und
        nachvollziehbar.
      </Line>

      <div
        className='cin-cue'
        style={anim({ at: [-1, 0], out: [0.02, 0.08], oy: 20 })}
      >
        <ArrowDownIcon width={18} height={18} />
        Scroll los
      </div>
    </div>
  )
}
